{
  "version": 1,
  "asset_id": "f421eb71-9550-498b-a2c6-c969b2bad120",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/f421eb71-9550-498b-a2c6-c969b2bad120/entities-teaser.webm",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/f421eb71-9550-498b-a2c6-c969b2bad120/entities-teaser.webm",
  "original_filename": "entities-teaser.webm",
  "size": 1324467,
  "content_type": "video/webm",
  "created_at": "2026-10-14T00:46:03Z"
}
